export default __webpack_public_path__ + "static/media/viandeseche.2fea33f0.jpg";